"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SimpleImageViewer = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _previewImgs = _interopRequireDefault(require("./previewImgs.vue"));
var _CustomImageViewer = _interopRequireDefault(require("./CustomImageViewer.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 默认图片预览组件
var _default = exports.default = {
  install: function install(vue) {
    var PreviewConstructor = vue.extend(_previewImgs.default);
    var instance = new PreviewConstructor();
    instance.$mount(document.createElement('div'));
    document.body.appendChild(instance.$el);
    _vue.default.prototype.$previewImg = function (imageList) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var tips = arguments.length > 2 ? arguments[2] : undefined;
      instance.imageList = imageList;
      instance.index = index;
      instance.tips = tips;
      instance.open();
    };
  }
}; // 自定义图片预览组件（无工具栏）
var SimpleImageViewer = exports.SimpleImageViewer = _CustomImageViewer.default;